import { Globals } from "../CoreApp/Globals";

export function startprtimer() {
  var d1 = new Date();
  Globals._pageTimer = d1.getTime();
}
